import { createFileRoute } from '@tanstack/react-router'
import { ScScribeReviewPage } from '@/features/support-coordination/scribe/review'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/scribe/$noteId',
)({
  component: ScScribeReviewPage,
})
